export enum HomeBoxId {
    DataMapping = 'data-mapping',
    AiGovernance = 'ai-governance',
    PrivacyRisk = 'privacy-risk',
    Dsr = 'dsr',
    Workspace = 'workspace',
}
